<template>
  <div class="">
    <v-tabs v-model="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{ tab.title }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "FactorTabs",
  data() {
    return {};
  },
  props: {
    type: {
      default: 'rc'
    },
    pre_factor: {
      default: false
    },
  },
  mounted() {
  },
  computed: {
    selectedTab() {
      if (this.$route.name == 'FactorForm' && this.type == 'rc' && this.pre_factor == false) {
        return 0
      }
      if (this.$route.name == 'FactorsList' && this.type == 'rc' && this.pre_factor == false) {
        return 1
      }
      if (this.$route.name == 'FactorForm' && this.type == 'rm' && this.pre_factor == false) {
        return 2
      }
      if (this.$route.name == 'FactorsList' && this.type == 'rm' && this.pre_factor == false) {
        return 3
      }


      if (this.$route.name == 'FactorForm' && this.type == 'cw' && this.pre_factor == false) {
        return 0
      }
      if (this.$route.name == 'FactorsList' && this.type == 'cw' && this.pre_factor == false) {
        return 1
      }


      if (this.$route.name == 'FactorForm' && this.type == 'sale' && this.pre_factor == true) {
        return 0
      }
      if (this.$route.name == 'FactorsList' && this.type == 'sale' && this.pre_factor == true) {
        return 1
      }
      if (this.$route.name == 'FactorForm' && this.type == 'buy' && this.pre_factor == true) {
        return 2
      }
      if (this.$route.name == 'FactorsList' && this.type == 'buy' && this.pre_factor == true) {
        return 3
      }


      if (this.$route.name == 'FactorForm' && this.type == 'buy' && this.pre_factor == false) {
        return 0
      }
      if (this.$route.name == 'FactorsList' && this.type == 'buy' && this.pre_factor == false) {
        return 1
      }
      if (this.$route.name == 'FactorForm' && this.type == 'backFromBuy' && this.pre_factor == false) {
        return 2
      }
      if (this.$route.name == 'FactorsList' && this.type == 'backFromBuy' && this.pre_factor == false) {
        return 3
      }


      if (this.$route.name == 'FactorForm' && this.type == 'sale' && this.pre_factor == false) {
        return 0
      }
      if (this.$route.name == 'FactorsList' && this.type == 'sale' && this.pre_factor == false) {
        return 1
      }
      if (this.$route.name == 'FactorForm' && this.type == 'backFromSale' && this.pre_factor == false) {
        return 2
      }
      if (this.$route.name == 'FactorsList' && this.type == 'backFromSale' && this.pre_factor == false) {
        return 3
      }


      if (this.$route.name == 'FactorForm' && this.type == 'fpi' && this.pre_factor == false) {
        return 0
      }


    },
    tabs() {
      if ((this.type == 'backFromBuy' || this.type == 'buy') && this.pre_factor == false) {
        return [
          {title: 'ثبت فاکتور خرید', key: 'form', type: 'buy', pre_factor: false},
          {title: 'لیست فاکتور خرید', key: 'list', type: 'buy', pre_factor: false},
          {title: 'ثبت فاکتور برگشت از خرید', key: 'form', type: 'backFromBuy', pre_factor: false},
          {title: 'لیست فاکتور برگشت از خرید', key: 'list', type: 'backFromBuy', pre_factor: false},
        ]
      }
      if ((this.type == 'backFromSale' || this.type == 'sale') && this.pre_factor == false) {
        return [
          {title: 'ثبت فاکتور فروش', key: 'form', type: 'sale', pre_factor: false},
          {title: 'لیست فاکتور فروش', key: 'list', type: 'sale', pre_factor: false},
          {title: 'ثبت فاکتور برگشت از فروش', key: 'form', type: 'backFromSale', pre_factor: false},
          {title: 'لیست فاکتور برگشت از فروش', key: 'list', type: 'backFromSale', pre_factor: false},
        ]
      }
      if (this.type == 'rc' || this.type == 'rm') {
        return [
          {title: 'ثبت رسید', key: 'form', type: 'rc', pre_factor: false},
          {title: 'لیست رسید', key: 'list', type: 'rc', pre_factor: false},
          {title: 'ثبت حواله', key: 'form', type: 'rm', pre_factor: false},
          {title: 'لیست حواله', key: 'list', type: 'rm', pre_factor: false},
        ]
      }
      if (this.type == 'cw') {
        return [
          {title: 'ثبت حواله کالای مصرفی', key: 'form', type: 'cw', pre_factor: false},
          {title: 'لیست حواله کالای مصرفی', key: 'list', type: 'cw', pre_factor: false},
        ]
      }
      if (this.type == 'fpi') {
        return [
          {title: 'موجودی اول دوره', key: 'form', type: 'fpi', pre_factor: false},
        ]
      }
      if (this.pre_factor == true){
        return [
          {title: 'ثبت پیش فاکتور فروش', key: 'form', type: 'sale', pre_factor: true},
          {title: 'لیست پیش فاکتور فروش', key: 'list', type: 'sale', pre_factor: true},
          {title: 'ثبت پیش فاکتور خرید', key: 'form', type: 'buy', pre_factor: true},
          {title: 'لیست پیش فاکتور خرید', key: 'list', type: 'buy', pre_factor: true},
        ]
      }
    },
  },
  methods: {
    changeRoute(tab) {
      if(tab.key == 'form'){
        this.$router.push('/panel/factor/form/' + tab.pre_factor + '/' + tab.type)
      }
      else if (tab.key == 'list'){
        this.$router.push('/report/lists/factors/' + tab.type + '/' + tab.pre_factor)
      }

    }
  }

};
</script>

<style scoped lang="scss">
</style>

